import {
  Box,
  Container,
  makeStyles,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from '@material-ui/core'
import React from 'react'
import { Translate } from 'react-localize-redux'

const useStyles = makeStyles((theme) => ({
  stepperTitle: {
    fontSize: 24,
  },
  heading: {
    fontSize: 48,
  },
  subHeading: {
    fontSize: 16,
  },
  stepper: {
    padding: 10,
    paddingBottom: 0,
    '& .MuiStepIcon-text': {
      fill: theme.palette.text.primary,
      fontSize: '10px',
      fontWeight: 600,
    },
    '& .MuiSvgIcon-root': {
      width: '40px',
      height: '40px',
    },
    '& .MuiStepConnector-alternativeLabel': {
      top: '20px',
      left: 'calc(-50% + 25px)',
      right: 'calc(50% + 25px)',
      position: 'absolute',

      '& .MuiStepConnector-line': {
        borderColor: theme.palette.text.primary,
      },
    },
    '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
      fontSize: '14px',
      fontWeight: 600,
      marginTop: '10px',
    },
  },
}))

const CallToActionHeader = () => {
  const classes = useStyles()

  return (
    <Container className={classes.root}>
      <Box textAlign="center">
        <Box>
          <Typography variant="h1" className={classes.stepperTitle}>
            <Translate id="team.choose-plan" />
          </Typography>
        </Box>
        <Box width="60%" mx="auto">
          <Stepper alternativeLabel className={classes.stepper}>
            <Step>
              <StepLabel active>
                <Translate id="myteams.create-team" />
              </StepLabel>
            </Step>
            <Step>
              <StepLabel active>
                <Translate id="team.choose-your-plan" />
              </StepLabel>
            </Step>
          </Stepper>
        </Box>
      </Box>
      <Box textAlign="center" my={12}>
        <Box mb={2}>
          <Typography variant="h1" className={classes.heading}>
            <Translate id="team.elevate-journey" />
          </Typography>
        </Box>
        <Box width="75%" mx="auto">
          <Typography className={classes.subHeading}>
            <Translate id="team.elevate-journey-subheading" />
          </Typography>
        </Box>
      </Box>
    </Container>
  )
}

export default CallToActionHeader
